import styled from "@emotion/styled"

export interface StylesProps {
  isMobile: boolean
}

export const Logo = styled.object<StylesProps>`
  height: ${({ isMobile }) => !isMobile && "8%"};
  background: transparent;
  position: absolute;
  top: 0px;
  left: 0px;
  margin: ${({ isMobile }) => !isMobile && "0.75rem 0 0 1rem"};
  z-index: 1000000;
  width: ${({ isMobile }) => isMobile && "30px"};
  height: ${({ isMobile }) => isMobile && "30px"};
  min-height: 30px;
`
